module.exports = __webpack_public_path__ + "static/media/3circulos.3a5139ba.svg";